<template>
  <section class="guides" :class="{ desktop: $isDesktop }">
    <h2>Glamping Guides</h2>
    <lazy-article-list :specific-articles-data="GLAMPING_GUIDES" />
  </section>
</template>

<script setup lang="ts">
const GLAMPING_GUIDES = [
  {
    title: 'Glamping guides',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/4/image/private/s--zCxTwzLB--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1643095496/653994_y3drh4.jpg',
    url: '/guides/glamping/',
  },
  {
    title: 'Types of glamping',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/3/image/private/s--Z5EHEGDc--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1646481127/478142_typl1h.jpg',
    url: '/guides/glamping/types/',
  },
  {
    title: 'Top Tips For Glamping With A Dog',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/4/image/private/s--sjZCA9Cs--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1650310644/pexels-cottonbro-5365048_vdvnt5.jpg',
    url: '/guides/glamping/glamping-with-dogs/',
  },
  {
    title:
      'Budget glamping: how to cut costs while camping in style with Pitchup',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/5/image/private/s--SHc-teQL--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1650962390/673335_tn9hz1.jpg',
    url: '/guides/glamping/budget/',
  },
  {
    title: '9 of the best camping and glamping pods in the UK',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/2/image/private/s--TiJ_em4T--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1646516094/loch-tay-highland-lodges-12_p7wp6g.jpg',
    url: '/guides/glamping/types/glamping-and-camping-pods/',
  },
  {
    title: 'The best glampsites for yurt holidays In the UK',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/1/image/private/s--yB0bpkVV--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1646569722/yang-shuo-_Zbbs4muqkQ-unsplash_lt9ciz.jpg',
    url: '/guides/glamping/types/yurts/',
  },
  {
    title: 'Best geodesic dome holidays in the UK',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/5/image/private/s--zHx-OYCD--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1649934083/dome_jjmicc.jpg',
    url: '/guides/glamping/types/dome-tents/',
  },
  {
    title: '10 of the best shepherd’s hut stays in the UK',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/3/image/private/s--1gMQ6hyv--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1646770948/wood-g7e6d8f799_1280_ccu83n.jpg',
    url: '/guides/glamping/types/shepherd-huts/',
  },
  {
    title: 'Best tipi holidays in the UK',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/2/image/private/s--Etke2CDA--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1649933739/tipe-3449759_1280_ecrsvc.jpg',
    url: '/guides/glamping/types/tipi-and-wigwams/',
  },
]
</script>
<style scoped>
.guides {
  background-color: var(--colour-page-background-light);
  width: 100vw;
  padding-bottom: 1em;
}

h2 {
  padding: 0.75em 1em 0.25em;
  color: var(--colour-dark-blue);
  font-size: 1.35em;
}

.guides :deep(ul.articles) {
  grid-template-columns: repeat(5, 83vw);
}

.guides :deep(ul.articles a) {
  align-items: center;
}

.guides :deep(.scrollable) {
  overflow-x: auto;
  overflow-y: visible;
  padding: 1em 1.4em;
  scroll-padding: 0 1.4em;
  scroll-snap-type: x mandatory;
}

.desktop.guides {
  width: auto;
}

.desktop.guides h2 {
  padding: 1em 1em 0.25em var(--page-width-padding);
}

.desktop.guides :deep(ul.articles.desktop) {
  grid-template-columns: repeat(5, 30ch);
  padding: 1em var(--page-width-padding) 2em;
  overflow-x: auto;
  overflow-y: visible;
  column-gap: 1em;
  row-gap: 1.5em;
}

.desktop.guides :deep(ul.articles.desktop .title) {
  font-size: inherit;
}

.desktop.guides :deep(ul.articles.desktop .picture) {
  width: 5em;
  height: 5em;
  border-radius: 0.75em;
  margin-right: 1em;
}

@supports (scrollbar-width: none) {
  .guides :deep(.scrollable) {
    scrollbar-width: none;
  }

  .desktop.guides :deep(.scrollable) {
    scrollbar-width: thin;
  }
}

@supports selector(::-webkit-scrollbar) {
  .guides :deep(.scrollable:not(.desktop)::-webkit-scrollbar) {
    display: none;
  }
}
</style>
